module.exports = __webpack_public_path__ + "img/p03.96447b49.jpg";